(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gg-atelier-media')) {
    customElements.define('gg-atelier-media', class extends HTMLElement {
      connectedCallback() {
        this.syncRatio = () => {
          const media = this.querySelector('.gg-lab__media--base') || this.querySelector('gg-film video');
          if (!media) return;
          const width = media.videoWidth || media.naturalWidth;
          const height = media.videoHeight || media.naturalHeight;
          if (!width || !height) return;
          const ratio = width / height;
          this.style.setProperty('--atelier-ratio', String(ratio));
          this.dataset.labRatioD = this.dataset.labRatioM = `${width}/${height}`;
        };
        this.addEventListener('loadedmetadata', this.syncRatio, true);
        this.addEventListener('load', this.syncRatio, true);
        this.observer = new MutationObserver(this.syncRatio);
        this.observer.observe(this, { childList: true, subtree: true });
        this.syncRatio();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.removeEventListener('loadedmetadata', this.syncRatio, true);
        this.removeEventListener('load', this.syncRatio, true);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
